import { Injectable } from '@angular/core';
import { IServerError, INavigationError, IServerErrorResponse } from '../validation/models/server-error.models';
import { HttpErrorResponse } from '@angular/common/http';

@Injectable({providedIn: 'root'})
export class ErrorUtilitiesService {

    /**
     * Extract user-friendly error message from various error formats
     * Priority: responseException.exceptionMessage > error.message > status text
     */
    extractErrorMessage(error: any): string {
        // Handle null/undefined
        if (!error) {
            return 'An unknown error occurred';
        }

        // Handle HttpErrorResponse
        if (error instanceof HttpErrorResponse) {
            // Check if error body has responseException
            if (error.error?.isError && error.error?.responseException?.exceptionMessage) {
                return error.error.responseException.exceptionMessage;
            }
            // Check for direct message in error body
            if (error.error?.message) {
                return error.error.message;
            }
            // Fall back to status text
            if (error.statusText) {
                return `${error.status}: ${error.statusText}`;
            }
        }

        // Handle plain object with responseException
        if (error.isError && error.responseException?.exceptionMessage) {
            return error.responseException.exceptionMessage;
        }

        // Handle Error object or object with message property
        if (error.message) {
            return error.message;
        }

        // Handle string errors
        if (typeof error === 'string') {
            return error;
        }

        // Last resort
        return 'An error occurred while processing your request';
    }

    parseFieldErrors(error: IServerError) {
        const parsedErrors: Array<{ fieldName: string, errorMessage: string }> = [];
        if (error && error.details && error.details.length > 0) {
            error.details.forEach(detail => {
                const fieldName = detail.target;
                const errorMessage = detail.message ? detail.message : error.message;
                parsedErrors.push({ fieldName: fieldName, errorMessage: errorMessage });
            });
        }
        return parsedErrors;
    }

    parseModelErrors(error: IServerError | string) {
        if (error && (<IServerError>error).message) {
            return [(<IServerError>error).message];
        }
        return [<string>error];
    }

    parseNavigationError(error: INavigationError) {
        let errorsFromServer = [];
        if (error) {
            if (error.message) {
                errorsFromServer = this.parseServerError(error.message);
            } else if (error.serverError) {
                errorsFromServer = this.parseServerError(error.serverError);
            }
        }
        return errorsFromServer;
    }

    parseServerError(error: IServerError | string) {
        let errorsFromServer: Array<string> = [];
        if (typeof error === 'string') {
            errorsFromServer = [error];
        } else if (error) {
            if (error.details && error.details.length > 0) {
                error.details.forEach(detail => {
                    const errorMessage = detail.message ? detail.message : error.message;
                    errorsFromServer.push(errorMessage);
                });
            }
            if (error.message) {
                if (!errorsFromServer.find(detailError => {
                    return detailError === error.message;
                })) {
                    errorsFromServer.unshift(error.message);
                }
            }
        }

        return errorsFromServer;
    }
}

